import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const cardContainer = css`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: ${spacing(1)};
  padding: ${spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${spacing(1.5)};
  border: 1px solid rgba(255, 255, 255, 0.1);
`

export const cardContent = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`

export const teamInfo = css`
  display: flex;
  align-items: center;
  gap: ${spacing(1.5)};
`

export const logoContainer = css`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const logoImage = css`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`

export const logoPlaceholder = css`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* backgroundColor will be set dynamically */
`

export const logoText = css`
  color: ${colors.white100};
  margin: 0;
  font-size: 10px;
  font-weight: 700;
`

export const teamNameText = css`
  color: ${colors.white100};
  margin: 0;
  font-size: 12px;
  font-weight: 600;
`

export const actionSection = css`
  position: absolute;
  top: 0;
  right: 0;
`

export const bookmarkButton = css`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  transition: all 0.2s ease;
  border-radius: 4px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`

export const seeAllGamesButton = css`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  width: 100%;
  
  &:hover {
    opacity: 0.8;
  }
`

export const seeAllGamesText = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-size: 10px;
`

export const arrowIcon = css`
  width: 10px;
  height: 10px;
  color: rgba(255, 255, 255, 0.7);
` 